// src/components/ExpandableNavItem/index.jsx
import { useState } from "react";
import "./index.css";

export default function ExpandableNavItem({ text, icon, isOpen = false, children }) {
  const [open, setOpen] = useState(!!isOpen);

  const toggle = (e) => {
    e.preventDefault();
    setOpen((v) => !v);
  };

  // Accept either a string of classes or a React node (e.g., <FlaticonIcon/>)
  const renderIcon = () =>
    !icon
      ? null
      : typeof icon === "string"
      ? <i className={`nav-icon ${icon}`} aria-hidden="true" />
      : <span className="nav-icon">{icon}</span>;

  return (
    <li className={`nav-item ${open ? "menu-open" : ""}`}>
      {/* Keep parent neutral (no 'active' class) */}
      <a className="nav-link" href="#/" onClick={toggle} aria-expanded={open}>
        {renderIcon()}
        <p>
          {text}
          {/* LUI caret (works with Qlik styles already in your app) */}
          <i className="right lui-icon lui-icon--arrow-left" aria-hidden="true"></i>
        </p>
      </a>

      <ul className="nav nav-treeview" style={{ display: open ? "block" : "none" }}>
        {children}
      </ul>
    </li>
  );
}
